import { List, Misc, Model } from "@singularsystems/neo-core";
import { NeoGrid } from "@singularsystems/neo-react";
import { IGenericApiClient } from "../../../ApiClients/Catalogues/GenericApiClient";
import { CatalogueEntry } from "../CatalogueEntry";
import * as CatalogueRoles from "../../../Models/Security/CatalogueRoles"
import { AppService, DomainTypes, Types } from "../../../DomainTypes";
import Rate from "../../../Models/Catalogue/Pipeline/Rate";
import { Catalogue } from "@singularsystems/neo-react-services";
import AuthoriseButton from "../../../Components/AuthoriseButton";
import CatalogueAuthorisation from "../CatalogueAuthorisation";
import { NotificationDuration } from "../../../../App/Models/NotificationDuration";

export default class RateCatalogueEntry extends CatalogueEntry<Rate> {

  private pipelinesApiClient = AppService.get(DomainTypes.ApiClients.CataloguePipeline);
  private notifications = AppService.get(Types.Neo.UI.GlobalNotifications);

  constructor() {
    super("Rates", Rate);
  }

  public get editRole() {
    return CatalogueRoles.Rates.Edit;
  }

  public get ratesList(): List<Rate> {
    // TODO: fix when base property is made visible
    return (this as any).editState.editList;
  }

  private cloneRate() {
    const lastRate = this.ratesList.sortBy(c => c.rateDate, "desc")[0];
    let newRate: Rate;
    if (lastRate) {
      newRate = lastRate.clone();
      newRate.rateDate = null;
      newRate.rateId = 0;
      newRate.isPendingDelete = false;
      newRate.isNew = true;
    } else {
      newRate = new Rate();
    }
    this.ratesList.push(newRate);
  }

  public renderList() {
    return <NeoGrid.Grid items={this.ratesList} addButton={{ onClick: () => this.cloneRate() }}>
      {(item, meta) => this.renderRow(item, meta)}
    </NeoGrid.Grid>
  }

  public getFetchEndpoint(apiClient: IGenericApiClient) {
    return this.pipelinesApiClient.getRates;
  }

  public getSaveEndpoint(apiClient: IGenericApiClient) {
    return this.pipelinesApiClient.saveRates;
  }

  public renderRow(item: Rate, meta: Model.TransformMetaType<Rate>) {
    return (
      <NeoGrid.Row>
        <NeoGrid.Column bind={meta.rateDate} />
        <NeoGrid.Column bind={meta.taxRate}
          numProps={{ format: Misc.NumberFormat.PercentDecimals }} />
        <NeoGrid.Column bind={meta.basel3Retail}
          numProps={{ format: Misc.NumberFormat.PercentDecimals }} />
        <NeoGrid.Column bind={meta.basel3NonRetail}
          numProps={{ format: Misc.NumberFormat.PercentDecimals }} />
        <NeoGrid.Column bind={meta.liquidityCost}
          numProps={{ format: Misc.NumberFormat.PercentDecimals }} />
        <NeoGrid.Column bind={meta.trustThreshold} />
        <NeoGrid.Column bind={meta.companyThreshold} />
        <NeoGrid.Column bind={meta.defaultCommissionRate}
          numProps={{ format: Misc.NumberFormat.PercentDecimals }} />
        <NeoGrid.Column bind={meta.dwtRate}
          numProps={{ format: Misc.NumberFormat.PercentDecimals }} />
        <NeoGrid.ButtonColumn>
          <AuthoriseButton
            className="me-2"
            viewModel={CatalogueAuthorisation.authorisationVM}
            currentRecord={item}
            authoriseRoleName={CatalogueRoles.Rates.Authorise}
            onDelete={() => {
              this.editState.editList.removeWithoutTracking(item);
            }}
            />
        </NeoGrid.ButtonColumn>

        <Catalogue.ButtonColumn
          deleteButton={{
            onClick: () => {
              if (item.isNew) {
                this.editState.editList.removeWithoutTracking(item);
              }
              else {
                item.isPendingDelete = !item.isPendingDelete;
                if (item.isPendingDelete) {
                    this.notifications.addInfo("Mark Deleted", `Please click save to action this request.`, NotificationDuration.Standard);
                }
              }
            },
            icon: item.isPendingDelete ? "trash-restore" : "trash",
            tooltip: item.isPendingDelete ? "Stop the rate from being removed when authorised."
                                          : "Mark the rate to be removed when authorised."
          }} />
      </NeoGrid.Row>
    )
  }
}